import { Controller } from "remult";

@Controller("community-association-methods")
export class CommunityAssociationMethods {}
